import { render, staticRenderFns } from "./WinnersBlock.vue?vue&type=template&id=1fb04214&scoped=true&"
import script from "./WinnersBlock.vue?vue&type=script&lang=js&"
export * from "./WinnersBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb04214",
  null
  
)

export default component.exports